import React, { useReducer } from "react";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";

import clienteAxios from "../../config/axios";
import tokenAuth from "../../config/token";

import Alert from "./../../components/Alert";

import {
  REGISTRO_EXITOSO,
  REGISTRO_ERROR,
  OBTENER_USUARIO,
  LOGIN_EXITOSO,
  LOGIN_ERROR,
  CERRAR_SESION,
  VALIDAR_SESION,
} from "../../types";
import { error } from "jquery";

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem("token"),
    autenticado: null,
    usuario: null,
    mensaje: null,
    cargando: true,
    loading: false,
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const registrarUsuario = async (datos) => {
    try {
      const respuesta = await clienteAxios.post("/api/usuarios", datos);
      console.log(respuesta.data);

      dispatch({
        type: REGISTRO_EXITOSO,
        payload: respuesta.data,
      });

      // Obtener el usuario
      usuarioAutenticado();
    } catch (error) {
      // console.log(error.response.data.msg);
      const alerta = {
        msg: error.response.data.msg,
        categoria: "alerta-error",
      };

      dispatch({
        type: REGISTRO_ERROR,
        payload: alerta,
      });
    }
  };

  // Retorna el usuario autenticado
  const usuarioAutenticado = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      tokenAuth(token);
    } else {
      dispatch({
        type: LOGIN_ERROR,
      });
      return;
    }

    try {
      //const respuesta = await clienteAxios.get("/api/login");
      // console.log(respuesta);
      dispatch({
        type: OBTENER_USUARIO,
        payload: "Juan Demo",
      });
    } catch (error) {
      console.log(error.response);
      dispatch({
        type: LOGIN_ERROR,
      });
    }
  };

  // Cuando el usuario inicia sesión
  const iniciarSesion = async (datos) => {
    try {
      const respuesta = await clienteAxios.post("/api/login", datos);

      if (
        respuesta &&
        respuesta.data &&
        respuesta.data.msg &&
        respuesta.data.token
      ) {
        dispatch({
          type: LOGIN_EXITOSO,
          payload: respuesta.data,
        });

        // Obtener el usuario
        usuarioAutenticado();
      } else {
        throw new error("error de validación");
      }
    } catch (error) {
      console.log(error.response.data.msg);
      const alerta = {
        msg: error.response.data.msg,
        categoria: "alerta-error",
      };
      dispatch({
        type: LOGIN_ERROR,
        payload: alerta,
      });
      Alert({
        title: "Atención!",
        type: "error",
        text: alerta.msg,
      });
    }
  };
  const validarSesion = () => {
    dispatch({
      type: VALIDAR_SESION,
    });
  };
  const validarSesionError = () => {
    dispatch({
      type: LOGIN_ERROR,
    });
  };
  // Cierra la sesión del usuario
  const cerrarSesion = () => {
    dispatch({
      type: CERRAR_SESION,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        autenticado: state.autenticado,
        usuario: state.usuario,
        mensaje: state.mensaje,
        cargando: state.cargando,
        loading: state.loading,
        registrarUsuario,
        iniciarSesion,
        usuarioAutenticado,
        cerrarSesion,
        validarSesion,
        validarSesionError,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
export default AuthState;
